import { SET_APP_LANGUAGE } from "../action/lang.action";

const initialState = {
    language: localStorage.getItem("appLanguage") || "en",
};

export default function langReducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_APP_LANGUAGE:
            return { ...state, language: action.payload };
        default:
            return state;
    }
}
